<template>
    <div>
        <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
            <el-input class="cls-height" type="number" v-model="config[field.key]" :placeholder="field.memo"></el-input>
        </el-form-item>
    </div>
</template>

<style lang="scss">
    .el-input__inner{
        padding: 0 25px 0 15px;
    }
    .cls-height:after{
        position: absolute;
        right: 10px;
        content: 'px';
        font-size: 14px;
        color: #999;
    }
</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */
    export default {
        name: 'tms-type-height',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            source: {
                type: String,
            }
            // config: {
            //     type: Object,
            //     default() {
            //         return {}
            //     }
            // }
        },
        computed: {
            config() {
                if (this.source === 'tmsPageConfig') {
                return this.$store.state.tms.pageData
                }
                if (this.source === 'tmsModuleConfig') {
                return this.$store.state.tms.config;
                }
                return this.$store.state.tms.customConfig;
            }
        },
        components: {},

        mounted() {

        },

        methods: {}
    }

</script>
